import React, { useState } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
} from 'reactflow';

/** Purpose: render a labeled, styled connection between flow nodes. Why: branch conditions need readable visual distinction beyond a plain canvas line. */
export default function PremiumEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style = {},
  label,
  selected,
  data = {},
}) {
  const [hovered, setHovered] = useState(false);
  const accent = style.stroke || data.color || '#38bdf8';
  const emphasized = selected || hovered || data.isActive;
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 18,
    offset: 28,
  });

  return (
    <>
      {emphasized ? (
        <path
          d={edgePath}
          fill="none"
          stroke={accent}
          strokeWidth={selected ? 9 : 7}
          strokeOpacity={selected ? 0.16 : 0.1}
          className="pointer-events-none"
        />
      ) : null}
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        interactionWidth={28}
        style={{
          ...style,
          stroke: accent,
          strokeWidth: selected ? 3.25 : (emphasized ? 2.75 : style.strokeWidth || 2.25),
          filter: emphasized ? `drop-shadow(0 2px 4px ${accent}40)` : undefined,
          transition: 'stroke-width 150ms ease, filter 150ms ease',
        }}
      />
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth="24"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="react-flow__edge-interaction cursor-pointer"
      />
      {(label || data?.analytics) ? (
        <EdgeLabelRenderer>
          <div
            className="nodrag nopan pointer-events-none absolute flex items-center gap-1.5 rounded-full border bg-white/95 px-2.5 py-1 text-[10px] font-bold text-slate-700 shadow-[0_5px_15px_rgba(15,23,42,0.12)] backdrop-blur-md transition-transform dark:bg-slate-950/95 dark:text-slate-100"
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px) scale(${emphasized ? 1.06 : 1})`,
              borderColor: `${accent}55`,
            }}
          >
            <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: accent, boxShadow: `0 0 0 3px ${accent}20` }} />
            {label ? <span className="max-w-[140px] truncate">{label}</span> : null}
            {data?.analytics ? (
              <span className="rounded bg-sky-100/90 px-1.5 py-0.5 text-[9px] font-black text-sky-800 dark:bg-sky-950 dark:text-sky-300">
                {data.analytics.traversals} ({data.analytics.percentage}%)
              </span>
            ) : null}
          </div>
        </EdgeLabelRenderer>
      ) : null}
    </>
  );
}
